import loading from '../../resources/images/loading.svg'

export const Loading = () => (
  <div>
    <img src={loading} alt="Loading" />
  </div>
)
